export const EXPIRATION_DAY_OPTIONS = [30, 90, 180, 365] as const;

export const DEFAULT_EXPIRATION_DAYS = 180;
